import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { EPartners, EPartnerType } from '~/features/partners/models'

const REPLIFY_PARTNER_TYPES = [
  EPartnerType.default,
  EPartnerType.secondaryReplify,
]

const useIsPartner = () => {
  const { partner } = usePartnerCentralized()

  const isPartner =
    !!partner?.partnerName &&
    partner?.partnerName !== EPartners.replify &&
    !REPLIFY_PARTNER_TYPES.includes(partner?.partnerType)

  return isPartner
}

export default useIsPartner
